import React from 'react';

/**
 * @private This hook is currently private because it's missing tests and documentation.
 * @since 10.5.0
 */
function useScrollableTabIndex(active, loading, containerRef) {
  var _a, _b, _c, _d;
  const [scrollHeight, setScrollHeight] = React.useState((_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0);
  const [offsetHeight, setOffsetHeight] = React.useState((_d = (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0);
  const [tabIndexValue, setTabIndexValue] = React.useState(undefined);
  React.useEffect(() => {
    if (active && !loading && containerRef.current) {
      setScrollHeight(containerRef.current.scrollHeight);
      setOffsetHeight(containerRef.current.offsetHeight);
    }
  }, [active, loading, containerRef.current]);
  React.useEffect(() => {
    const hasScroll = scrollHeight > offsetHeight;
    setTabIndexValue(hasScroll ? 0 : undefined);
  }, [scrollHeight, offsetHeight]);
  return tabIndexValue;
}

export { useScrollableTabIndex };
